import { Injectable } from '@angular/core';
import { Observable, forkJoin } from 'rxjs';

import {
  IApplication,
  ICreateApplicationRequest,
  IUpdateApplicationRequest,
} from './defs';
import { RequestService } from '../request';
import { HttpParams } from '@angular/common/http';

const BASE_URL = '/api/applications';

@Injectable({
  providedIn: 'root',
})
export class ApplicationsService {
  constructor(private request: RequestService) {}

  public getApplications(query = {}): Observable<IApplication[]> {
    let params = new HttpParams();

    // Agregar cada par clave-valor del objeto query como parámetro de consulta
    Object.keys(query).forEach((key) => {
      params = params.append(key, query[key]);
    });

    // Realizar la solicitud con los parámetros de consulta
    if (params.keys().length > 0) {
      return this.request.get<IApplication[]>(BASE_URL, { params });
    } else {
      return this.request.get<IApplication[]>(BASE_URL);
    }
  }

  public createApplication(
    request: ICreateApplicationRequest
  ): Observable<IApplication> {
    return this.request.post(BASE_URL, request);
  }

  public updateApplication(
    request: IUpdateApplicationRequest
  ): Observable<IApplication> {
    return this.request.put(`${BASE_URL}/${request.id}`, request);
  }

  public deleteApplications(ids: number[]): Observable<IApplication[]> {
    return forkJoin(ids.map((id) => this.request.delete(`${BASE_URL}/${id}`)));
  }
}
